import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'

class CommonSynopticTemplateAttachmentService {
    async getLastExternalDocumentation(templateId: number): Promise<AxiosResponse<Blob>> {
        const config: AxiosRequestConfig = {
            headers: { 'content-type': 'multipart/form-data' },
            responseType: 'blob'
        }
        return axios.get<Blob>(`common/synopticTemplates/${templateId}/attachments/lastExternalDocumentation`, config)
    }
}
export const commonSynopticTemplateAttachmentService = new CommonSynopticTemplateAttachmentService()
